<template>
  <b-container fluid>
    <!-- Agent Information -->
    <b-row class="mb-3">
      <b-col md="6">
        <strong>Agent ID</strong>
        <div><b-badge variant="primary">{{ propWrkAgentObj.agent_id || "N/A" }}</b-badge></div>
      </b-col>
      <b-col md="6">
        <strong>Agent Name</strong>
        <div><b-badge variant="primary">{{ propWrkAgentObj.agent_name || "N/A" }}</b-badge></div>
      </b-col>
    </b-row>

    <!-- Module & Domain -->
    <b-row class="mb-3">
      <b-col md="6">
        <strong>Module Name</strong>
        <div><b-badge variant="primary">{{ propWrkAgentObj.module_name || "N/A" }}</b-badge></div>
      </b-col>
      <b-col md="6">
        <strong>App Domain</strong>
        <div><b-badge variant="primary">{{ propWrkAgentObj.app_domain || "N/A" }}</b-badge></div>
      </b-col>
    </b-row>

    <!-- Agent Description -->
    <b-row class="mb-3">
      <b-col>
        <iq-card class="p-3">
          <template v-slot:body>
            <h6 class="mb-3">Agent Description</h6>
            <div v-if="propWrkAgentObj.agent_desc" class="content-view-container">
              <pre class="content-display">{{ propWrkAgentObj.agent_desc }}</pre>
            </div>
            <div v-else class="text-muted">No Description Found</div>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <!-- Action -->
    <b-row class="mb-3">
      <b-col>
        <iq-card class="p-3">
          <template v-slot:body>
            <h6 class="mb-3">Actions</h6>
            <div v-if="actionList.length > 0">
              <!-- <b-badge v-for="action in actionList" :key="action" variant="secondary" class="mr-2 mb-2">{{ action }}</b-badge> -->
              <ol class="mb-0">
                <li v-for="(action, index) in actionList" :key="index" class="mb-1 text-black">{{ action }}</li>
              </ol>
            </div>
            <div v-else class="text-muted">No Actions Found</div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"

export default {
  name: "wrkAgentView",
  props: {
    propWrkAgentObj: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  computed: {
    actionList () {
      if (!this.propWrkAgentObj.action) {
        return []
      }

      return this.propWrkAgentObj.action.split(",").map(item => item.trim()).filter(Boolean)
    }
  },
  mounted () {
    socialvue.index()
  }
}
</script>

<style scoped>
.content-view-container {
  max-height: 500px;
  overflow-y: auto;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.content-display {
  margin: 0;
  padding: 16px;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.6;
  font-family: Consolas, Monaco, monospace;
}
</style>
